import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { buttonIcon, translucentDark } from "css/buttons"
import getMediaQuery, { media } from "css/breakpoints"

const IN_DURATION = 600
const OUT_DURATION = 200
export const KILL_DURATION = 300
const IN_EASE = "1,1,1,1" //".32,.94,.6,1"
const OUT_EASE = "1,1,1,1" //".22,1,.36,1"
const KILL_EASE = "1,1,1,1" //".22,1,.36,1"
const SCALE_DURATION = 600
const SCALE_EASE = ".32,.94,.6,1"

export const wv_willfade = css`
  opacity: 0;
  visibility: hidden;
  transition: opacity ${OUT_DURATION}ms cubic-bezier(${OUT_EASE}) 0ms, visibility 0ms linear ${OUT_DURATION}ms;
  will-change: opacity, visibility;
  &.wv_reveal {
    transition: opacity ${IN_DURATION}ms cubic-bezier(${IN_EASE}) 0ms, visibility 0ms 0ms;
    opacity: 1;
    visibility: visible;
  }
  .wv_kill & {
    transition: opacity ${KILL_DURATION}ms cubic-bezier(${KILL_EASE}) 0ms, visibility 0ms linear ${KILL_DURATION}ms;
  }
`

export const wv_willtransform = (from, to) => css`
  transition: none;
  will-change: transform;
  transform: ${from};
  &.wv_trans {
    transition: transform ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE}) 0ms;
    transform: ${to};
  }
`

export const wv_imgheight = css`
//  min-height: 390px;
  height: 48vh;
  margin-top: -2vh;
  .wvIncard & {
    min-height: unset !important;
//    max-height: unset !important;
    height: 16rem;
    margin-top: -1rem;
  }

  ${getMediaQuery("s")} {
//    min-height: 300px;
    margin-top: 0vh;
  }
    
  ${getMediaQuery("m")} {
    .wvIncard & {
      height: 27rem;
      margin-top: -2rem;
    }
  }
  
  ${getMediaQuery("l")} {
    //    height: min(60vh,380px);
    min-height: 390px;
    height: 60vh;
    margin-top: 0vh;

    .wvIncard & {
      height: 18rem;
    }
  }

  ${getMediaQuery("xxll")} {
    .wvIncard & {
      height: 22rem;
      margin-top: -2.5rem;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    min-height: 240px;  
    max-height: 300px;
  }
  @media (min-width: 768px) and (hover: hover) and (pointer: fine) {
      max-height: 530px;
  }
`

export const Modal = styled.div`
  visibility: hidden;
  opacity: 0;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: min(100%, 100dvh);
  overflow-y: auto;
  transform: translateZ(0);
  background: #fafafa;
  display: grid;
  align-items: center;
  overscroll-behavior: none;
  align-content: center;

  &.wv_reveal {
    transition: opacity 400ms cubic-bezier(0.61, 1, 0.88, 1) 0ms, visibility 0ms 0ms;
    opacity: 1;
    visibility: visible;
  }

  &.wv_hide {
    > button {
      visibility: hidden;
    }
  }

  &:focus-within {
    nav {
      visibility: visible;
    }
  }

  &.mv-nofocus {
    & .focus-visible {
      outline-color: transparent !important;
      & + span {
        outline-color: transparent !important;
      }
    }
  }
`

export const Main = styled.div`
  position: relative;
  z-index: 6;
  min-height: ${({ headerHeight }) => `calc(100svh - var(${headerHeight}) + 3px)`};
  box-sizing: border-box;
  display: grid;
  background: linear-gradient(0deg, #f0f0f0, #fff);
  overflow: hidden;

  padding-block-start: 1.875rem;

  --wv-cover-scale: 1.2;
  @media ${media.landscape} {
    --wv-cover-translate-Y: 5vh;
  }
  @media ${media.portrait} {
    --wv-cover-translate-Y: 0vh;
  }
  --wv-cover-transform-origin: 50% 0%;
  transition: transform ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE}), height ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE});

  &.wv_reveal {
    height: 100svh;
    overflow-y: scroll;
    transform: ${({ headerHeight }) => `translateY(calc(-1 * var(${headerHeight})))`};

    &:focus-within {
      nav {
        visibility: visible;
      }
    }
  }
`

export const Splitter = styled.div`
  position: relative;
  z-index: 0;
  display: grid;
  grid-template-rows: min-content 1fr;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  user-select: none;
  --outer-margin: calc(.08 * min(100vw, 1920px));

  height: 100%;
  height: min(100%, 100dvh);

  ${getMediaQuery("xl")} {
    height: auto;
    grid-template-rows: 1fr;
    grid-template-columns: 35% 65%;
  }
`

export const Wrapper = styled.div`
  ${getMediaQuery("xl", { max: true })} {
    opacity: 0;
    visibility: hidden;
    transition: opacity ${OUT_DURATION}ms cubic-bezier(${OUT_EASE}) 0ms, visibility 0ms linear ${OUT_DURATION}ms;
    .cfg-toggled & {
      z-index: 2;
      transition: opacity ${IN_DURATION}ms cubic-bezier(${IN_EASE}) 300ms, visibility 0ms 0ms;
      opacity: 1;
      visibility: visible;
    }
  }

  position: relative;
  z-index: 1;
  grid-row: 2;
  grid-column: 1/-1;
  ${getMediaQuery("xl")} {
    grid-row: 1;
    grid-column: 2;
  }
`

export const ToggleButton = styled.button`
  cursor: pointer;
  left: 50%;
  position: absolute;
  top: 30px;
  transform: translateX(-50%);

  ${getMediaQuery("xl")} {
    display: none;
  }
`

export const Starter = styled.div`
  ${getMediaQuery("xl", { max: true })} {
    transition: opacity ${IN_DURATION}ms cubic-bezier(${IN_EASE}) 300ms, visibility 0ms 0ms;
    opacity: 1;
    visibility: visible;
    .cfg-toggled & {
      z-index: 1;
      opacity: 0;
      visibility: hidden;
      transition: opacity ${OUT_DURATION}ms cubic-bezier(${OUT_EASE}) 0ms, visibility 0ms linear ${OUT_DURATION}ms;
    }
  }

  position: relative;
  z-index: 2;
  grid-row: 2;
  grid-column: 1/-1;
  ${getMediaQuery("xl")} {
    border-inline-end: 1px solid rgba(179, 179, 179, 0.5);
    grid-row: 1;
    grid-column: 1;
  }
`

export const Close = styled.button`
  ${wv_willfade}
  ${buttonIcon}
  ${translucentDark}
  --v-spacing: 1.875rem;
  --h-spacing: 0;
  ${getMediaQuery("m")} {
    --v-spacing: 3.125rem;
    --h-spacing: 3.125rem;
  }
  inset-block-start: var(--h-spacing);
  inset-inline-end: var(--v-spacing);
  position: absolute;
  z-index: 501;
`

export const Marker = styled.div`
  position: relative;
  height: 0;
  visibility: hidden;
`
